export default __webpack_public_path__ + "static/code-0be617f27c57e95898bb93528f452653.png";